export default "__VITE_ASSET__CCuI$CA6__"